const iFrameManager = (function () {
    return {
        loadSilentRenewIFrame: loadSilentRenewIFrame,
        removeIFrameOnTimeout: removeIFrameOnTimeout,
        loadCheckSessionIFrame: loadCheckSessionIFrame,
        checkSessionIFrameStatus: checkSessionIFrameStatus
    };

    function loadSilentRenewIFrame(url) {
        var silentRenewIFrame = document.createElement('iframe');
        silentRenewIFrame.id = 'silent-renew-iframe';
        silentRenewIFrame.src = url;
        silentRenewIFrame.style.display = 'none';
        document.body.appendChild(silentRenewIFrame);

        return silentRenewIFrame;
    }

    var tokenReceiveTimeout;
    function removeIFrameOnTimeout(iFrameId) {

        tokenReceiveTimeout = setTimeout(() => {
            cleanUpIFrame(iFrameId);
        }, 10000);
    }

    function cleanUpIFrame(iFrameId) {
        removeIFrame(iFrameId);
        clearTimeout(tokenReceiveTimeout);
    }

    function removeIFrame(iFrameId) {
        var element = document.getElementById(iFrameId);
        if (element) {
            element.parentNode.removeChild(element);
        }
    }

    function loadCheckSessionIFrame(url, onIframeLoad, followSessionCb) {
        var checkSessionIFrame = document.createElement('iframe');
        var checkSessionIFrameUrl = url + '/authorize/api/oauth2/check_session_iframe';
        checkSessionIFrame.id = 'iframeCheckSessionIframe';
        checkSessionIFrame.src = checkSessionIFrameUrl;
        checkSessionIFrame.style.display = 'none';
        checkSessionIFrame.onload = onIframeLoad;
        document.body.appendChild(checkSessionIFrame);

        if (followSessionCb) {
            window.addEventListener('message', receiveSessionStatus, false);
        }

        function receiveSessionStatus(event) {

            var origin = event.origin || event.originalEvent.origin;
            //if (origin !== 'https://idam-dev.metrosystems.net') { //Local
            if (origin !== (location.protocol + '//' + location.host)) {
                return;
            }

            followSessionCb(event.data);
        }

        return checkSessionIFrame;
    }

    function checkSessionIFrameStatus(clientId) {
        var sessionState = localStorage.getItem('session_state_lp2'); //Local

        var text = clientId + " " + sessionState;
        var iframe = document.getElementById("iframeCheckSessionIframe");
        //iframe.contentWindow.postMessage(text, 'https://idam-dev.metrosystems.net'); //Local
        iframe.contentWindow.postMessage(text, (location.protocol + '//' + location.host));
        return Promise.resolve();
    }

});

export default iFrameManager;
